<template>
  <div class="english1_container">
    <!-- 게임 레벨 선택 메뉴 -->
    <div class="english1_ready" v-show="gameMode === 'ready'">
      <img src="../assets/english1/english1_main.png" alt="" />
      <div class="english1_title">
        English word
        <br />
        Quiz
      </div>
      <div style="margin-top: 30px;" />
      <v-btn
        elevation="1"
        x-large
        width="250px"
        color="#bcb8b1"
        @click="startQuiz(1)"
      >
        <v-icon left color="white" size="2rem">
          mdi-numeric-1-box
        </v-icon>
        <div class="english1_menu_text" style="padding-right:27px;">
          초등·중등 레벨
        </div>
      </v-btn>
      <div style="margin-top: 20px;" />
      <v-btn
        elevation="1"
        x-large
        width="250px"
        color="#8a817c"
        @click="startQuiz(2)"
      >
        <v-icon left color="white" size="2rem">
          mdi-numeric-2-box
        </v-icon>
        <div class="english1_menu_text" style="padding-right:74px;">
          수능 레벨
        </div>
      </v-btn>
      <div style="margin-top: 20px;" />
      <v-btn
        elevation="1"
        x-large
        width="250px"
        color="#463f3a"
        @click="startQuiz(3)"
      >
        <v-icon left color="white" size="2rem">
          mdi-numeric-3-box
        </v-icon>
        <div class="english1_menu_text" style="padding-right:33px;">
          미국 대학 레벨
        </div>
      </v-btn>
    </div>
    <!-- 종료 화면 -->
    <div class="english1_gameover" v-show="gameMode === 'gameover'">
      <!-- 캡쳐 -->
      <div class="english1_capture" ref="english1_capture">
        Lv. {{ level }}
        <br />
        your score
        <br />
        <div class="english1_share_record">
          {{ score }}
        </div>
        <div style="font-size: 1.2rem; color:tomato;">
          {{ word }}
        </div>
      </div>
      <div class="english1_share_text">
        share it with your friends
      </div>
      <share
        url="https://spready.net/english1"
        title="영어단어 퀴즈"
        :image="image"
      />
      <v-btn
        @click="reGame()"
        color="#6d6875"
        style="margin-top: 20px; color: white;"
      >
        New Game
      </v-btn>
    </div>
    <!-- 게임 화면 -->
    <div class="english1_game" v-show="gameMode === 'play'">
      <!-- 게임 상단 : 타이머, 스테이지 -->
      <div class="english1_game_header">
        <div class="english1_game_timer">
          <div class="english1_game_time_text">
            Time
          </div>
          <div class="english1_game_time_number">
            <Timer
              ref="timer"
              type="countdown"
              auto-start
              :length="60 * 1000"
              @done="onDone"
              v-slot="{ time, isOverflowed }"
            >
              <div>
                <span
                  :class="{ 'is-overflowed': isOverflowed }"
                  style="width: 100%; display:flex; justify-content: left;"
                >
                  <span>{{ time.s }}</span>
                </span>
              </div>
            </Timer>
          </div>
        </div>
        <div class="english1_game_stage">
          <div class="english1_game_stage_text">
            Score
          </div>
          <div class="english1_game_stage_number">
            {{ score }}
          </div>
        </div>
      </div>
      <!-- 게임 화면 -->
      <div class="english1_game_q">
        <label style="color:#999999; font-size: 0.7rem; text-align: left;">
          Question
        </label>
        <div class="english1_game_q_text">
          {{ question }}
        </div>
      </div>
      <div
        class="english1_game_a"
        v-for="(item, i) in currentWords"
        :key="item.id"
        @click="chkAnswer(i)"
      >
        <v-icon left color="white" size="2rem" style="margin: 0px 10px;">
          {{ getIconNumber(i + 1) }}
        </v-icon>
        {{ item.word }}
      </div>
    </div>
  </div>
</template>

<script>
import random from "lodash.random";
import { TimerVue as Timer } from "@josephuspaye/timer";
import Share from "./Share";

function dataURLtoFile(dataurl, filename) {
  let arr = dataurl.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, { type: mime });
}

export default {
  name: "English1",
  components: {
    Timer,
    Share
  },
  data() {
    return {
      words: [],
      currentWords: [],
      answer: "",
      word: "",
      question: "",
      gameMode: "ready",
      score: 0,
      image: null,
      level: ""
    };
  },
  methods: {
    newQuiz() {
      this.currentWords = [];
      let dup = {};
      let dupCnt = 0;
      /* 중복없이 4개 단어 뽑기 */
      for (let i = 0; i < 4; i++) {
        dupCnt = 0;
        let tmp = random(0, this.words.length - 1);
        for (let j = 0; j < dup.length; j++) {
          if (dup[j] == tmp) {
            dupCnt++;
          }
        }
        if (dupCnt == 0) {
          this.currentWords.push(this.words[tmp]);
        }
      }
      /* 4개중 하나를 뽑아서 답과 문제 만들기 */
      this.answer = random(0, 3);
      this.question = this.currentWords[this.answer].description;
      this.word = this.currentWords[this.answer].word;
    },
    /* 레벨을 선택하면 문제 목록을 읽어오고 게임 화면으로 전환 */
    async startQuiz(lv) {
      if (lv == 1) {
        const words = await fetch(
          "https://s3.ap-northeast-2.amazonaws.com/s.spready.net/english_beginner.json"
        ).then(res => res.json());
        this.words = words;
        this.level = 1;
      } else if (lv == 2) {
        const words = await fetch(
          "https://s3.ap-northeast-2.amazonaws.com/s.spready.net/english_advance.json"
        ).then(res => res.json());
        this.words = words;
        this.level = 2;
      } else if (lv == 3) {
        const words = await fetch(
          "https://s3.ap-northeast-2.amazonaws.com/s.spready.net/english_expert.json"
        ).then(res => res.json());
        this.words = words;
        this.level = 3;
      }
      this.gameMode = "play";
      this.newQuiz();
    },
    getIconNumber(num) {
      return "mdi-numeric-" + num + "-box";
    },
    chkAnswer(num) {
      if (this.answer == num) {
        this.score++;
        this.newQuiz();
      } else {
        this.gameMode = "gameover";
      }
    },
    reGame() {
      this.gameMode = "ready";
    },
    onDone() {
      this.gameMode = "gameover";
      this.word = "";
    },
    async capture() {
      const englishscoreScreen = this.$refs.english1_capture;
      const options = {
        type: "dataURL",
        scale: 2
      };
      const image = await this.$html2canvas(englishscoreScreen, options);
      const file = dataURLtoFile(image, "englishscoreScreen.png");
      this.image = file;
    }
  },
  watch: {
    gameMode: {
      async handler(value) {
        if (value === "gameover") {
          await this.capture();
        } else if (value === "ready") {
          this.$refs.timer.reset();
          this.score = 0;
        } else if (value === "play") {
          this.$refs.timer.reset();
          this.$refs.timer.toggle();
        }
      }
    }
  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@400&family=Staatliches&display=swap");

.english1_container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: top;
  flex-direction: column;
  font-family: "Noto Sans KR", sans-serif;
  color: #ffffff;
  background: #e8e8e4;
}
.english1_ready {
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: top;
  flex-direction: column;
}
.english1_gameover {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}
.english1_game {
  margin-top: 10px;
  width: 300px;
}
.english1_title {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  font-size: 2.7rem;
  color: gray;
  font-family: "Staatliches", cursive;
  line-height: 1;
  margin-top: 20px;
}
.english1_menu_text {
  font-size: 1.1rem;
  margin-left: 15px;
  color: #ffffff;
}
.english1_game_q {
  width: 300px;
  height: 110px;
  background: #ffffff;
  border-radius: 10px;
  box-shadow: 0px 0px 3px #bcb8b1;
  padding: 5px 20px;
  font-family: "Noto Sans KR", sans-serif;
}
.english1_game_q_text {
  color: #000000;
  font-size: 0.9rem;
  margin-top: 10px;
  word-break: break-all;
  text-align: left;
}
.english1_game_a {
  width: 100%;
  height: 50px;
  background: #6d6875;
  margin: 20px 0;
  color: #ffffff;
  border-radius: 5px;
  box-shadow: 0px 0px 3px #bcb8b1;
  display: flex;
  align-items: center;
  justify-content: left;
  text-align: left;
  cursor: pointer;
}
.english1_game_header {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: row;
  font-size: 0.8rem;
}
.english1_game_timer {
  width: 40%;
  height: 100%;
  color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: row;
}
.english1_game_stage {
  width: 40%;
  display: flex;
}
.english1_game_time_text {
  width: 50%;
  color: #999999;
}
.english1_game_time_number {
  width: 50%;
}
.english1_game_stage_text {
  width: 50%;
  color: #999999;
}
.english1_game_stage_number {
  width: 30%;
  color: black;
}
.english1_capture {
  padding: 50px 70px 30px 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  font-size: 1.5rem;
  color: gray;
  font-family: "Staatliches", cursive;
  background: #e8e8e4;
}
.english1_share_record {
  font-size: 2.2rem;
  color: #000000;
}
.english1_share_text {
  font-size: 1rem;
  color: darkgray;
  font-family: "Staatliches", cursive;
  margin-bottom: 10px;
}
</style>
